import { Row, Col, Card, CardBody } from "reactstrap";
import { EDUCATION_FIELDS } from "./CONSTANT";
import { FieldInput } from "../../../components/FieldInput";

export default function EducationForm({ validation }) {
  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {EDUCATION_FIELDS.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
